import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular'
import {
    BrowserCacheLocation,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser'

import { environment } from '@environments/environment'

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.auth.clientId,
            authority: environment.msalConfig.auth.authority,
            redirectUri: environment.msalConfig.redirectUri,
            postLogoutRedirectUri: environment.msalConfig.redirectUri,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            allowRedirectInIframe: true,
            loggerOptions: {
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false,
            },
        },
    })
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, string[]>()
    protectedResourceMap.set(environment.apiConfig.uri, environment.apiConfig.scopes)

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.apiConfig.scopes],
        },
        loginFailedRoute: '/',
    }
}
